<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="form" :inline="true" size="mini" label-width="50px">
        <el-form-item label="工号" class="employeeCode">
          <el-input v-model.trim="form.employeeCode">
            <template slot="prepend">QY-</template>
          </el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model.trim="form.employeeName"></el-input>
        </el-form-item>
        <el-form-item label="店铺">
          <el-select v-model="form.storeCode" placeholder="请选择">
            <el-option
              v-for="item in storesList"
              :key="item.storeCode"
              :label="item.storeName"
              :value="item.storeCode">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="search">搜索</el-button>
        <el-button type="warning" size="small" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" @click="add">新增</el-button>
      </template>
      <el-table
        :data="tableData"
        border
        ref="table"
        :height="maxTableHeight"
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column label="QY工号" prop="employeeCode" width="120px" show-overflow-tooltip></el-table-column>
        <el-table-column label="姓名" prop="employeeName" width="120px" show-overflow-tooltip></el-table-column>
        <el-table-column label="店铺权限" prop="storeName" show-overflow-tooltip></el-table-column>
        <el-table-column label="更新人" prop="updatedBy" width="120px"></el-table-column>
        <el-table-column label="更新时间" prop="updatedDate" width="200px"></el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
            <el-link type="primary" :underline="false" style="color: red" @click="delRow(scoped.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
            background
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- dialog -->
    <v-dialog v-model="dialogVisible" :config="dialogConfig" @dialogConfirm="dialogConfirm">
      <div slot="content">
        <add-edit ref="content" :data="rowData" :authOptions="authOptionsList" v-if="dialogVisible"></add-edit>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import addEdit from './components/add&edit/add&edit';

export default {
  components: { addEdit },
  mixins: [tableMixin],
  data() {
    return {
      form: {},
      tableData: [],
      loading: false,
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      authOptionsList: [],
      dialogVisible: false,
      dialogConfig: {},
      rowData: {},
      storesList: []
    };
  },
  mounted() {
    this.$set(this.form, 'storeCode', '');
    this.init();
    this.storeSelect();
    this.userDataPermissionStores();
  },
  methods: {
    // 列表初始化
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        employeeCode: this.form.employeeCode ? 'QY-' + this.form.employeeCode : '',
        employeeName: this.form.employeeName,
        storeCode: this.form.storeCode,
        permissionType: 1,
      };
      let res = await this.$q.shortVideoOverview.userDataPermissionSearch({ data });
      if (res.success && res.data && res.data.records.length) {
        this.tableData = res.data.records;
        this.$set(this.paginationOpt, 'total', res.data.total);
      } else {
        this.tableData = [];
        this.paginationOpt.total = 0;
      }
      this.loading = false;
    },
    storeSelect() {
      this.$q.product.storeSelect({}).then((res) => {
        this.authOptionsList = res.data;
      });
    },
    userDataPermissionStores() {
      this.$q.shortVideoOverview.userDataPermissionStores({}).then((res) => {
        this.storesList = res.data;
      });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    // 搜索
    search() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 重置
    reset() {
      this.paginationOpt.pageNum = 1;
      this.paginationOpt.pageSize = this.paginationOpt.pageSizes[0];
      this.form = {};
      this.$set(this.form, 'storeCode', '');
      this.init();
    },
    // 新增 弹出dialog
    add() {
      this.dialogConfig = {
        title: '新增',
        width: '40%',
        confirmCallback: true
      };
      this.rowData = {};
      this.dialogVisible = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.dialogConfig = {
        title: '编辑',
        width: '40%',
        confirmCallback: true
      };
      this.rowData = row;
      this.dialogVisible = true;
    },
    // 弹窗 确认事件
    dialogConfirm() {
      if (JSON.stringify(this.rowData) === '{}') {
        this.insertList();
      } else {
        this.updateList();
      }
    },
    // 新增接口
    async insertList() {
      let data = this.$refs['content'].formData;
      let { employeeCode, employeeName, storeCode, userId } = data;
      let permissionType = 1;
      let res = await this.$q.shortVideoOverview.userDataPermissioneEditUserData({ data: { employeeCode, employeeName, storeCode, userId, permissionType } });
      if (res.success) {
        this.$message.success('新增成功');
      } else {
        this.$message.fail('新增失败');
      }
      this.dialogVisible = false;
      this.init();
    },
    // 修改接口
    async updateList() {
      let data = this.$refs['content'].formData;
      data['id'] = this.rowData['id'];
      let { id, employeeCode, employeeName, storeCode, userId } = data;
      let permissionType = 1;
      let res = await this.$q.shortVideoOverview.userDataPermissioneEditUserData({ data: { id, employeeCode, employeeName, storeCode, userId, permissionType } });
      if (res.success) {
        this.$message.success('修改成功');
      } else {
        this.$message.fail('修改失败');
      }
      this.dialogVisible = false;
      this.init();
    },
    async delRow(row) {
      let status = await this.$confirm("是否确认删除该条数据？", '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let res = await this.$q.shortVideoOverview.userDataPermissionDeleteUserData({ fragment: [row.userId] });
      if (res.success) {
        this.$message.success('删除成功');
      } else {
        this.$message.fail('删除失败');
      }
      this.init();
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

.footerBox
  text-align right

>>> .el-input-group__prepend
  padding: 0 10px !important

.employeeCode
  >>> .el-input
    width: 170px
</style>
